// WhatsApp click-to-chat for the TinyLoan "Retain" message. Opens the user's own WhatsApp with a
// pre-filled message for a single customer — nothing is sent automatically (manual send in WhatsApp).
const RETAIN_MESSAGE = (name) => {
  const first = (name || "").trim().split(/\s+/)[0] || "there";
  return `Hi ${first}, welcome back to TinyLoan.\n\n` +
    `You've previously used TinyLoan for your loan requirement. If you have a new financial requirement, ` +
    `you can get in touch with our team to explore available loan options.\n\n` +
    `Contact TinyLoan:\n011-46013451\n+91-9873526008\n+91-9971641468\ntinyloan.in`;
};

// Normalize an Indian phone for wa.me (defaults to +91 when no country code). Returns "" if invalid.
const waNumber = (p) => {
  const d = (p || "").replace(/\D/g, "");
  if (d.length < 10) return "";
  return d.length === 10 ? `91${d}` : d;
};

// Opens WhatsApp click-to-chat with the Retain message pre-filled. Shows a toast if no valid phone.
export const openRetainWhatsApp = (account, toast) => {
  const num = waNumber(account?.mobile);
  if (!num) {
    toast?.error?.("No valid mobile number on this account — can't open WhatsApp.");
    return;
  }
  const url = `https://wa.me/${num}?text=${encodeURIComponent(RETAIN_MESSAGE(account?.borrower_name))}`;
  window.open(url, "_blank", "noopener,noreferrer");
};
